// extracted by mini-css-extract-plugin
export default {"rotate":"canrotate_rotate__9rMtO"};